const DMB_SELECTORS = 'dmb-selectors';
const OPERATION_SELECTED = 'operation-selected';
const OPERATION_SELECTED_OWNER = 'operation-selected-owner';
const ITEMS = [DMB_SELECTORS, OPERATION_SELECTED, OPERATION_SELECTED_OWNER];

export function clearSessionStorage() {
  ITEMS.forEach((item) => {
    sessionStorage.removeItem(item);
  });
}
